import Consumer from './ServicesConsumer'
import generateContextHOC from 'onyx-common/generateContextHOC'

export default generateContextHOC(Consumer, 'services')
